<h4>{{brandName}} Business Account Application Received</h4>
<div class="row">
    <div class="col-md-12">
        <div class="form-group">
            We have received your application for a {{brandName}} Business Account. Once your application is reviewed, we will contact you using the contact information you have provided.
            Click <a [routerLink]="['/login']"> here </a> to login to an existing {{brandName}} account.
        </div>
    </div>
</div>
